export const questions: Array<[string, string]> = [
  [
    'Educational level?',
    "Secondary schools, technical institutions, vocational programs, universities. Adaptable to your students' needs.",
  ],
  ['International?', 'Yes. Updated for 2026, works globally with regional adaptation guidance.'],
  ['Editable?', 'Yes. Customize with your name, institution, or local examples.'],
  ['Currency?', 'USD. Auto-converts to your local currency.'],
  [
    'What makes it different?',
    'Complete system: 6 coherent volumes, 5 exclusive bonuses, structured assessments, ready-made lessons, comprehensive dictionary, 14 integrated lesson structures. Everything designed so you never improvise again.',
  ],
  ['Not satisfied?', '7-day refund. 100% money back, no questions.'],
];
